module.exports = __webpack_public_path__ + "d356d9a4ea360133f8c870c9c868e7e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ears.png
// module id = 589
// module chunks = 0